import React, { useEffect, useState } from "react";
import { supabase } from "../services/SupabaseClient";
import TrainingCard from "./TrainingCard";

export default function TrainingListItems() {
  const [trainings, setTrainings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchTrainings() {
      try {
        const { data, error } = await supabase
          .from("Educations")
          .select("*")
          .order("id", { ascending: true });

        if (error) throw error;
        setTrainings(data);
      } catch (err) {
        console.error("Error fetching trainings:", err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchTrainings();
  }, []);

  if (loading) {
    return (
      <div className="training-list-loading">
        <p>Loading trainings...</p>
      </div>
    );
  }

  if (!trainings.length) {
    return (
      <div className="training-list-empty">
        <p>No trainings found.</p>
      </div>
    );
  }

  return (
    <div className="training-list">
      <div className="workshop-header">
        <h2>Education & Training</h2>
        <p>Formal education, professional training programs, workshops, and certifications.</p>
      </div>
      {trainings.map((training) => (
        <TrainingCard key={training.id} {...training} />
      ))}
    </div>
  );
}
